export default {
    namespaced: true,
    state: {
        idSegnalazione: null,
        tipoSegnalazione: -1,
        statoSegnalazione: -1,
        enteGestore: -1,
        soloDaCro: false
    },
    mutations: {
        SET_ID_SEGNALAZIONE: (state: any, payload: number) => (state.idSegnalazione = payload),
        SET_TIPO_SEGNALAZIONE: (state: any, payload: number) => (state.tipoSegnalazione = payload),
        SET_STATO_SEGNALAZIONE: (state: any, payload: number) => (state.statoSegnalazione = payload),
        SET_SOLO_DA_CRO: (state: any, payload: number) => (state.soloDaCro = payload),
        SET_ENTE_GESTORE: (state: any, payload: number) => (state.enteGestore = payload)
    },
    actions: {
        resettaFiltri({commit}: any) {
            commit('SET_ID_SEGNALAZIONE', null)
            commit('SET_TIPO_SEGNALAZIONE', -1)
            commit('SET_STATO_SEGNALAZIONE', -1)
            commit('SET_SOLO_DA_CRO', false)
            commit('SET_ENTE_GESTORE', -1)
        }
    }
}
